export default {
  LIST (state, value) {
    state.list = value && Array.isArray(value) ? value : []
  },
  LIST_ADD (state, value) {
    if (state.list.findIndex((i) => i.id === value.id) === -1) {
      state.list.push({
        id: value.id,
        name: value.name,
        acronym: value.acronym,
        description: value.description,
        parent: value.parent,
        tagType: value.tagType
      })
    }
  },
  LIST_REMOVE (state, value) {
    const index = state.list.findIndex((i) => i.id === value)
    if (index !== -1) {
      state.list.splice(index, 1)
    }
  },
  LIST_UPDATE (state, value) {
    const index = state.list.findIndex((i) => i.id === value.id)
    if (index !== -1) {
      state.list.splice(index, 1, {
        id: value.id,
        name: value.name,
        acronym: value.acronym,
        description: value.description,
        parent: value.parent,
        tagType: value.tagType
      })
    }
  },
  CURRENT (state, value) {
    // need to make a more graceful update to minimize screen disruptions
    if (value) {
      for (const prop of ['id', 'name', 'acronym', 'description', 'parent', 'tagType']) {
        if (value[prop] !== state.current[prop]) {
          state.current[prop] = value[prop]
          state.update[prop] = value[prop]
        }
      }
      state.current.resources = value.resources || []
    } else {
      state.current = {
        id: '',
        name: '',
        acronym: '',
        description: '',
        parent: null,
        tagType: null,
        resources: []
      }
      state.update = {
        id: '',
        name: '',
        acronym: '',
        description: '',
        parent: null,
        tagType: null
      }
    }
  },
  UPDATE_NAME (state, value) {
    state.update.name = value
  },
  UPDATE_ACRONYM (state, value) {
    state.update.acronym = value
  },
  UPDATE_DESCRIPTION (state, value) {
    state.update.description = value
  },
  UPDATE_PARENT (state, value) {
    state.update.parent = value
  },
  UPDATE_TAG_TYPE (state, value) {
    state.update.tagType = value
  }
}
